<template>
  <div class="claim-card">
    <Typography variant="subtitle-1" class="header">
      Claim ID: {{ claim.formSubmissionEntryId }}
    </Typography>
    <div class="status-details">
      <ApprovedClaimDetails v-if="claim.reviewStatus === 'Approved'" :claim="claim" />
    </div>
    <ClaimProductInfo :claim="claim" class="product-info" includeDescription />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import ClaimProductInfo from "./claim-info/ClaimProductInfo.vue";
import ApprovedClaimDetails from "./claim-info/ApprovedClaimDetails.vue";
export default {
  components: {
    Typography,
    ClaimProductInfo,
    ApprovedClaimDetails,
  },
  name: "ClaimCard",
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.claim-card {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
}

.status-details {
  padding: 0.5rem;
  padding-left: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.header {
  padding: 0.5rem;
  padding-left: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.product-info {
  padding: 0.5rem;
  padding-left: 1rem;
}
</style>
